import { render } from "./CitasPorMotivo.vue?vue&type=template&id=4ac72fb9&scoped=true"
import script from "./CitasPorMotivo.vue?vue&type=script&lang=js"
export * from "./CitasPorMotivo.vue?vue&type=script&lang=js"

import "./CitasPorMotivo.vue?vue&type=style&index=0&id=4ac72fb9&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac72fb9"]])

export default __exports__